// ===========================================================================
// High Cost — módulo independiente.
//
// "Sala de control" del gasto: pestañas Patients/Analysis, ficha del paciente
// y editor de estratificación social. Controlador backend: /api/HighCost.
// Reemplaza al High Cost viejo de clinical-info (/clinical-info/high-cost,
// que ahora redirige aquí).
// ===========================================================================
import HighCostPage from "./pages/HighCostPage";
import HighCostPatientPage from "./pages/HighCostPatientPage";

export const highCostRoutes = [
  { path: "/high-cost", element: <HighCostPage /> },
  { path: "/high-cost/:cipId", element: <HighCostPatientPage /> },
];

export { default as HighCostPage } from "./pages/HighCostPage";
export { default as HighCostPatientPage } from "./pages/HighCostPatientPage";
export * from "./services";
export default HighCostPage;
